export enum MachineType {
  Harvester = 1,
  Forwarder = 2
}

export const MachineTypeLabels = {
  [MachineType.Harvester]: "Skördare",
  [MachineType.Forwarder]: "Skotare",
}
